import { Col, Colors, IcClose, IcDevice, IcEdit, IcMenuChange, IcPlay, IcTick, IcTrash } from 'basic-ui-lib';
import ScreenItemMobile from '../ScreenItemMobile';
import MenuActionMobile from 'basic-ui-lib/components/MenuActionMobile';
import useGetListScreens from 'modules/dashboard/services/hooks/useGetListScreens';
import { useState } from 'react';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { ItemMenuProps } from 'basic-ui-lib/components/MenuActionMobile/ItemMenu';
import { ScreenStatus } from 'modules/dashboard/services/constants';
import navigate from 'utils/navigate';

interface IScreenTableMobileProps {
  handleRefreshScreen: (screenId: string) => void;
  handlePreviewScreen: (screen: IScreen) => void;
  handleEditNameScreen: (screen: IScreen) => void;
  handleReactivateScreen: (screen: IScreen) => void;
  handleDeleteScreen: (screenId: string) => void;
}

const ScreenTableMobile = ({
  handleRefreshScreen,
  handlePreviewScreen,
  handleEditNameScreen,
  handleReactivateScreen,
  handleDeleteScreen,
}: IScreenTableMobileProps) => {
  const { screensList } = useGetListScreens(true);
  const [selectedScreen, setSelectedScreen] = useState<IScreen | null>(null);
  const [open, setOpen] = useState(false);

  const listMenu = [
    {
      key: 'refresh',
      title: 'Refresh',
      icon: <IcMenuChange width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'preview',
      title: 'Preview',
      icon: <IcPlay width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'edit-name',
      title: 'Edit Name',
      icon: <IcEdit width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'edit-content',
      title: 'Edit Content',
      icon: <IcDevice width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'reactivate',
      title: selectedScreen?.status === ScreenStatus.ONLINE ? 'Deactivate' : 'Activate',
      icon:
        selectedScreen?.status === ScreenStatus.ONLINE ? <IcClose width={20} height={20} fill={Colors.neutral.bg[7]} /> : <IcTick width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
    {
      key: 'delete',
      title: 'Delete Screen',
      icon: <IcTrash width={20} height={20} fill={Colors.neutral.bg[7]} />,
    },
  ];

  const handleSelectScreen = (item: IScreen) => {
    setSelectedScreen(item);
    setOpen(true);
  };

  const handleMenuClick = (item: ItemMenuProps) => {
    if (!selectedScreen) return;
    switch (item.key) {
      case 'refresh':
        handleRefreshScreen(selectedScreen.id);
        break;
      case 'preview':
        handlePreviewScreen(selectedScreen);
        break;
      case 'edit-name':
        handleEditNameScreen(selectedScreen);
        break;
      case 'edit-content':
        navigate(`/screen/${selectedScreen.id}`);
        break;
      case 'reactivate':
        handleReactivateScreen(selectedScreen);
        break;
      case 'delete':
        handleDeleteScreen(selectedScreen.id);
        break;
      default:
        break;
    }
    setOpen(false);
  };

  return (
    <Col flex={1}>
      {screensList?.content.map((item) => (
        <ScreenItemMobile key={item.id} item={item} onClickMenu={() => handleSelectScreen(item)} />
      ))}
      <MenuActionMobile listMenu={listMenu} open={open} onClose={() => setOpen(false)} onClickMenu={handleMenuClick} />
    </Col>
  );
};

export default ScreenTableMobile;
